import { Button, FormLabel, Input } from "@mui/material";
import { developAxios } from "../../axios.config";
import { FormEvent, useState } from "react";
import { useMutation } from "react-query";
import Select from "react-select";

type TtemplateItem = {
	label: string;
	key: string;
};

function not(a: TtemplateItem[], b: TtemplateItem[]) {
	return a.filter(
		(value) => !b.filter((b_val) => b_val.key === value.key)[0]
	);
}

function intersection(a: TtemplateItem[], b: TtemplateItem[]) {
	return a.filter(
		(value) => !!b.filter((b_val) => b_val.key === value.key)[0]
	);
}

function union(a: TtemplateItem[], b: TtemplateItem[]) {
	return [...a, ...not(b, a)];
}

const dashboardOptions = [
	{
		label: "Home",
		value: "Home",
	},
	{
		label: "Learning",
		value: "Learning",
	},
	{
		label: "Technical",
		value: "Technical",
	},
	{
		label: "Aptitude",
		value: "Aptitude",
	},
	{
		label: "Practise Test",
		value: "PractiseTest",
	},
	{
		label: "Project",
		value: "Project",
	},
	{
		label: "Company Preparation",
		value: "CompanyPreparation",
	},
	{
		label: "Company Training",
		value: "CompanyTraining",
	},
	{
		label: "Mock Interview",
		value: "MockInterview",
	},
];

function CreateTemplate() {
	const [name, setName] = useState("");
	const [selected, setSelected] = useState<
		ReadonlyArray<{
			value: string;
			label: string;
		}>
	>([
		{
			label: "Home",
			value: "Home",
		},
	]);

	const { mutateAsync: createDashboard } = useMutation(() => {
		const sideNavBar: { [item: string]: any } = {};

		selected.forEach((val) => {
			sideNavBar[val.value] = {};
		});

		return developAxios(localStorage.getItem("token") || "").post(
			"/admin/dashboard/create-dashboard-template",
			{
				sideNavBar,
				name,
			}
		);
	});

	function handleSubmit(e: FormEvent<HTMLFormElement>) {
		e.preventDefault();
		createDashboard();
	}

	return (
		<form onSubmit={handleSubmit} className="space-y-4">
			<div className="flex gap-3 font-semibold">
				<span className="text-red-600">*</span>
				<span>- Required Fields</span>
			</div>
			<div className="flex gap-4 items-center">
				<FormLabel htmlFor="name">
					Template Name
					<span className="text-red-600">*</span>
				</FormLabel>
				<Input
					id="name"
					value={name}
					onChange={(e) => setName(e.target.value)}
					required
				/>
			</div>
			<div className="flex gap-4 items-center">
				<Select
					options={dashboardOptions}
					closeMenuOnSelect={false}
					isMulti={true}
					value={selected}
					onChange={(val) => setSelected(val)}
				/>
			</div>
			<Button variant="contained" type="submit">
				Create Template
			</Button>
		</form>
	);
}

export default CreateTemplate;
